import React from "react";
import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import Reveal from "@/components/shared/Reveal";
import Seo from "@/components/shared/Seo";
import SpeakerAvatar from "@/components/shared/SpeakerAvatar";
import { ArrowLeft } from "lucide-react";

const SpeakerDetail = () => {
  const { slug } = useParams();
  const { data: sp, isLoading } = useQuery({ queryKey: ["speaker", slug], queryFn: async () => (await api.get(`/speakers/${slug}`)).data });

  if (isLoading) return <div className="min-h-screen bg-f2b-black" />;
  if (!sp) return <div className="min-h-screen bg-f2b-black flex items-center justify-center text-white pt-32">Intervenant introuvable.</div>;

  return (
    <>
      <Seo title={`${sp.name} — FACADES2build`} description={`${sp.function} — ${sp.company}. ${sp.bio?.slice(0, 140)}`} />
      <section className="bg-f2b-black pt-32 pb-20">
        <div className="f2b-container">
          <Link to="/intervenants" className="inline-flex items-center gap-2 text-white/60 text-sm hover:text-f2b-cyan mb-10"><ArrowLeft size={16} /> Tous les intervenants</Link>
          <div className="grid md:grid-cols-[340px_1fr] gap-12 items-start">
            <Reveal className="aspect-[4/5] overflow-hidden border border-white/10"><SpeakerAvatar speaker={sp} testid="speaker-detail-photo" /></Reveal>
            <Reveal delay={0.1}>
              <p className="f2b-kicker text-f2b-cyan mb-3">{sp.function}</p>
              <h1 className="font-display font-bold text-white text-4xl md:text-5xl leading-tight">{sp.name}</h1>
              <p className="f2b-lead text-white/70 text-xl mt-3">{sp.company}</p>
              {sp.bio && <p className="text-white/75 mt-8 leading-relaxed max-w-2xl">{sp.bio}</p>}

              {sp.conferences?.length > 0 && (
                <div className="mt-12">
                  <h2 className="f2b-kicker text-f2b-gray mb-5">Interventions</h2>
                  <div className="space-y-4">
                    {sp.conferences.map((c) => (
                      <div key={c.id} className="border-l-2 border-f2b-cyan pl-5 py-1">
                        <p className="font-display font-bold text-white text-lg leading-tight">{c.title}</p>
                        {c.key_takeaway && <p className="f2b-lead text-white/60 text-sm mt-1">« {c.key_takeaway} »</p>}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
};

export default SpeakerDetail;
